import { Button, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import { formatString } from "../../utilities/utilities";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

import { ASSETS_PATH } from "../../constants";
import { uploadAsset } from "../../utilities/assetUtils";

import CircularWithValueLabel from "../../components/CircularWithValueLabel";
import PopNarations from "../../components/PopNarations";
import PopLanguagesVideo from "../../components/PopLanguatesVideo";



const Screen = () => {

    const { screen_id } = useParams();
    const [content, setContent] = useState({});
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [narrations, setNarrations] = useState(null);
    const [videos, setVideos] = useState(null);


    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/setting/${screen_id}`, { method: 'GET' })
            .then((res) => res.json())
            .then((json) => {
                console.log(json.data.svalue);
                setContent(json.data.svalue);
            });
    }, []);


    const onChangeBeaconId = (e) => {
        const beacon_id = e.target.value;
        setContent({ ...content, beacon_id });
    }

    const onUploadBackgroundImage = (e) => {
        uploadAsset(e, (fileName) => { setContent({...content, background_image: fileName }) }, setUploading, setProgress);
    }

    const onRemoveBackgroundImage = () => {
        setContent({ ...content, background_image: "" })
    }



const onSetVideos = (videos) => {
        setContent({ ...content, videos: { ...videos } })
        setVideos(null);
    }

    const onVideosPopClose = () => {
        setVideos(null);
    }


    const onVideosPopup = () => {
        setVideos({ ...content.videos } || {});
    }

const onSetNarrations = (narrations) => {
        setContent({ ...content, narrations: { ...narrations } })
        setNarrations(null);
    }

    const onNarrationsPopClose = () => {
        setNarrations(null);
    }


    const onNarrPopup = () => {
        setNarrations({ ...content.narrations } || {});
    }

    const onSaveChanges = () => {
        const payload = {
            key: screen_id,
            value: content
        }

        fetch(`${process.env.REACT_APP_API_URL}/setting`, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        })
            .then(res => res.json())
            .then(json => {
                console.log(json);
                alert(json.message);
            })
            .catch(err => {
                console.log(err);
            })
    }


    return (
        <>
            <div className="content-header pb-6">
                {formatString(screen_id)} Screen
            </div>
            <div className="content-body flex flex-col gap-8 w-[400px]">
                <hr className="border-3 border-gray-700" />
                <div className="flex flex-row gap-4 items-center">
                    <div className="w-[130px]">Beacon ID:</div>
                    <TextField variant="outlined" size="small" fullWidth value={content.beacon_id || ''} onChange={onChangeBeaconId} />
                </div>
                {content && content.background_image &&
                    <>
                        <img src={`${ASSETS_PATH}/${content.background_image}`} width={400} alt="Background Image" />
                        <Button variant="outlined" color="error" onClick={onRemoveBackgroundImage}>Remove Background Image</Button>
                    </>}
                {!content.background_image && <Button variant="contained" component="label">Upload Background Image
                    <input
                        type="file"
                        hidden
                        onChange={onUploadBackgroundImage}
                    />
                </Button>}                
                <Button variant="contained" onClick={onVideosPopup}>Upload {formatString(screen_id)} Videos</Button>
                <Button variant="contained" onClick={onNarrPopup}>Upload Extended Audios</Button>
                <hr className="border-3 border-gray-700" />
                <Button variant="contained" color="success" onClick={onSaveChanges}>Save</Button>
            </div>
            {narrations && createPortal(<PopNarations narrations={narrations} onSetNarrations={onSetNarrations} onNarrationsPopClose={onNarrationsPopClose} />, document.getElementById('modal'))}
            {videos && createPortal(<PopLanguagesVideo videos={videos} onSetVideos={onSetVideos} onVideosPopClose={onVideosPopClose} />, document.getElementById('modal'))}
            {uploading && <CircularWithValueLabel progress={progress} />}
        </>
    )
}

export default Screen;